import { useAuth0 } from '@auth0/auth0-react';
import googleAnalyticsService from '../GoogleAnalyticsService';

let authContext: ReturnType<typeof useAuth0> | undefined = undefined;

export default class BackendAuthHandler {
  withAuthToken(): Promise<string | null> {
    if (!authContext) {
      return Promise.resolve(null);
    }

    const { isAuthenticated, user, getAccessTokenSilently } = authContext;

    if (!isAuthenticated || !user) {
      return Promise.resolve(null);
    }

    return getAccessTokenSilently({
      authorizationParams: {
        audience: process.env.REACT_APP_BACKEND_AUDIENCE, // 👈 must match your Auth0 API identifier
        scope: 'openid profile email',
      },
    });
  }

  async logout() {
    if (!authContext) {
      return;
    }

    const { logout, getIdTokenClaims, isAuthenticated, user } = authContext;

    const claims = await getIdTokenClaims();
    const idToken = claims?.__raw;

    // if there's a loggein user track logout via GA
    if (isAuthenticated && user) {
      googleAnalyticsService.trackLogoutAndFlush();
    }

    logout({
      logoutParams: {
        id_token_hint: idToken,
        returnTo: `${window.location.origin}`,
        client_id: process.env.REACT_APP_AUTH0_CLIENT_ID!,
      },
    });
  }
}

const setAuthContextOnBackendService = (context: ReturnType<typeof useAuth0>) => {
  authContext = context;
};

export { setAuthContextOnBackendService };
